import { combineReducers } from 'redux'
import { activeCategory } from 'components/hotelCategory/reducer'
import { sidebar } from 'components/slidingpane/reducer'

const hotelRatingState = combineReducers({
  activeCategory,
  sidebar
})

export default hotelRatingState
